import React from 'react';

const AppContext = React.createContext();
const AppContextConsumer = AppContext.Consumer;

export { AppContext, AppContextConsumer as default }